export default __webpack_public_path__ + "static/media/money-back@3x.e2977e3c.png";